import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'

type UnreadCandidate = Pick<ProgressReport, 'id' | 'is_viewed'>

export const PROGRESS_REPORTS_OPEN_QUERY = 'open'
export const PROGRESS_REPORTS_OPEN_UNREAD = 'unread'

export const findNewestUnreadReport = <T extends UnreadCandidate>(reports: T[]): T | null =>
  reports
    .filter((report) => !report.is_viewed)
    .reduce<T | null>((newest, report) => (!newest || report.id > newest.id ? report : newest), null)
